import Moon from "components/common/Moon";
import ServerClock from "components/common/ServerClock";
import { MEDIA_SIZE_LIST } from "libs/const";
import { Link } from "react-router-dom";
import styled from "styled-components";


const LeftView = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  font-size: 28px;
  font-weight: 600;

  img {
    position: relative;
    top: 2px;
    width: 100px;
  }
`;

const Clock = styled.div`
  & > div {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 18px;
    font-weight: 500;
  }
`;

const MoonView = styled.div`
  font-size: 18px;
  font-weight: 600;
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #48494A;
  gap: 20px;
  padding: 40px 20px;
  color: #ffffff;

  @media screen and (max-width: ${`${MEDIA_SIZE_LIST[1]}px`}) {
    flex-direction: column;
    gap: 10px;
    padding: 20px;

    ${Title} {
      font-size: 22px;
      gap: 12px;

      img {
        width: 60px;
      }
    }
  }
`;

const Header = () => {
  return <Container>
    <LeftView>
      <Title>
        <Link to="/">
          <img src="/assets/owl_logo.png" />
        </Link>
        <span>{"OWL-NET WEATHER FORECAST"}</span>
      </Title>
      <Clock>
        <ServerClock />
      </Clock>
    </LeftView>
    <MoonView>
      <Moon />
    </MoonView>
  </Container>
}

export default Header;